module.exports = __webpack_public_path__ + "img/apple-tv.9bc1c563.png";